module.exports = __webpack_public_path__ + "img/level_six_hover.aef70ef0.png";